import React from 'react';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import { Modal } from 'react-bootstrap';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { humanFileSize } from '../../../components/utils/format';
import { BigBreadcrumbs, WidgetGrid, JarvisWidget } from '../../../components';
import {
  requestCIRReport, requestAllLookups, saveCIRReport, requestGenders, uploadCIReportFiles,
  requestVisitorHealthTypes, requestEmployeeHealthTypes, requestImpactedTypes,
  requestHintLocationTypeahead, saveCIRReportTasks, deleteCIReportFile, downloadCIReportFile, previewCIReportFile,
  addCIReportComment, updateCIReportComment, deleteCIReportComment, requestTimeZones,
  requestIncidentStatuses, requestPatientHealthTypesByParentId, requestPatientHealthTypes
} from '../../../store/cir-manager/ClinicalIncidentActions';
import ClinicalIncidentForm from '../components/ClinicalIncidentForm';
import Comments from '../components/Comments';
import CommentForm from '../components/CommentForm';
import {
  requestClientEscalation,
  updateClientEscalation,
  requestPatientEscalation,
  updatePatientEscalation,
} from '../../../store/escalation-manager/EscalationManagerActions';
import { requestAllCIRLookups } from '../../../store/escalation-types/EscalationTypesActions';
import { requestUsersTypeahead } from '../../../store/users/UsersActions';
import { requestUserInfo } from '../../../store/current-user/CurrentUserActions';
import { requestClientsTypeahead } from '../../../store/client-manager/ClientManagerActions';
import { requestPatientsTypeahead } from '../../../store/patients/PatientsActions';
import { requestClinicLocationsTypeahead } from '../../../store/location-manager/LocationManagerActions';
import { requestClient } from '../../../store/client-manager/ClientManagerActions';
import { requestPatient } from '../../../store/patients/PatientsActions';
import { Link } from 'react-router';
import Moment from '../../../components/utils/Moment';
import { hostTitle } from '../../../config/ui';
import { isExecutive, isClinicalComplianceManager, isSuperAdmin } from '../../../store/current-user/CurrentUserSelectors';
import FileViewer from 'react-file-viewer';

class ClinicalIncidentReportEdit extends React.Component {
  constructor() {
    super();
    this.state = {
      files: [],
      showUpload: false,
      title: '',
      description: '',
      //showForm: false,
      //showLocationForm: false,
      showPreview: false,
      //fileName: null,
      //fileType: null,
    };
    this.removeFileFromUploadList = this.removeFileFromUploadList.bind(this);
    //this.renderEditable = this.renderEditable.bind(this);
    //this.renderEditableTags = this.renderEditableTags.bind(this);
    //this.renderEditableCategory = this.renderEditableCategory.bind(this);
    //this.renderEditableShared = this.renderEditableShared.bind(this);
  }

  componentWillMount() {
    //this.props.getAllLookups({
    //  tenantId: this.props.user.queryParams.tenantId,
    //});
    this.props.getCIRReport(this.props.params.id, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getCurrentUser();
    this.props.getPatientHealthTypes({
      tenantId: this.props.user.queryParams.tenantId,
      parentId: 0
    })
  }

  searchTaskUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 500,
        order: '',
        search,
        filters,
        roles: ['clinical operations manager', 'clinical compliance manager']
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            const email = item.email ? ` (${item.email})` : '';
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName}${email}`,
            });
          });
        }
        if (this.props.user) {
          const email = this.props.user.data.email ? ` (${this.props.user.data.email})` : '';
          options.push({
            id: this.props.user.data.id,
            name: `${this.props.user.data.firstName} ${this.props.user.data.lastName}${email}`,
          });
        }

        return options;
      });
  };

  searchUsers = (search, filters = '') => {
    return this.props
      .getUsersTypeahead({
        offset: 0,
        limit: 500,
        order: '',
        search,
        filters,
        roles: [ 'clinical operations manager' ]
      })
      .then((result) => {
        const options = [];
        if (result.payload.data && result.payload.data.list) {
          result.payload.data.list.forEach((item) => {
            const email = item.email ? ` (${item.email})` : '';
            options.push({
              id: item.id,
              name: `${item.firstName} ${item.lastName}${email}`,
            });
          });
        }
        return options;
      });
  };

  searchClients = (search) => {
    return this.props
      .clientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  searchStatuses = () => {
    return this.props.getIncidentStatuses({
      tenantId: this.props.user.queryParams.tenantId,
    })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        const newoptions = (this.props.isClinicalComplianceManager) ? options : options.filter((el) => el.name !== "Entered in Error");
        return newoptions;
      });
  };

  searchTypes = () => {
    return this.props
      .getImpactedTypes({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchTimeZones = () => {
    return this.props
      .getTimeZones({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchVisitorHealthTypes = () => {
    return this.props
      .getVisitorHealthTypes({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchEmployeeHealthTypes = () => {
    return this.props
      .getEmployeeHealthTypes({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchGenders = () => {
    return this.props
      .getGenders({
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchPatientHealthTypes = (parentId) => {
    return this.props
      .getPatientHealthTypesByTypeId({
        tenantId: this.props.user.queryParams.tenantId,
        parentId: parentId
      });
    //.then((result) => {
    //  const options = [];
    //  if (result.payload.data) {
    //    result.payload.data.forEach((item) => 
    //        options.push({ id: item.id, name: item.name })
    //    );
    //  }
    //  return options;
    //});
  };

  searchPatients = (search) => {
    return this.props
      .patientsTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  searchLocations = (search) => {
    return this.props
      .hintLocationTypeahead({
        tenantId: this.props.user.queryParams.tenantId,
        search,
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ code: item.code, name: item.name }),
          );
        }
        return options;
      });
  };

  onSubmit = (values) => {
    if(values.tasks) {
      values.tasks.forEach((item) =>
        item.assignedTo = item.assignedToItem.id);
      ;
    }
    this.props
      .saveReport(values, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          if (values.tasks) {
            values.tasks.forEach((item) =>
              this.props.saveReportTasks(item, result.payload.data, {
                tenantId: this.props.user.queryParams.tenantId,
              })
            );
          }
          toast.success('Report has been saved.');
          hashHistory.push(`/cir-manager/`);
        }
      });
  };

  onCancel = () => {
    hashHistory.push(`/cir-manager/`);
  };
  
  onDrop(files) {
    if (this.state.files.length === 0) {
      const filesToAdd = _.difference(files, this.state.files);
      this.setState({ files: this.state.files.concat(filesToAdd) });
    }
  }

  onFileCancel() {
    this.setState({
      files: [],
    });
  }

  showModal() {
    this.setState({ showUpload: true });
  }

  closeModal() {
    this.setState({ showUpload: false });
    this.onFileCancel();
  }

  removeFileFromUploadList(fileName) {
    this.setState({
      files: this.state.files.filter((file) => file.name !== fileName),
    });
  }

  onStartUpload() {
    this.props
      .uploadFiles(
        this.props.params.id,
        {
          tenantId: this.props.user.queryParams.tenantId,
          title: this.state.title,
          description: this.state.description
        },
        this.state.files,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showUpload: false, files: [] });
          this.props.getCIRReport(this.props.params.id, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  handleTitleChange(event) {
    this.setState({ title: event.target.value });
  }

  handleDescriptionChange(event) {
    this.setState({ description: event.target.value });
  }

  deleteFile(reportId, fileName) {
    this.props
      .deleteFile(reportId, fileName,
        {
          tenantId: this.props.user.queryParams.tenantId,
        }
      )
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('File has been deleted.');
          this.props.getCIRReport(this.props.params.id, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  onAddSubmit = (parentId, message) => {
    this.props
      .addMessage(message, {
        tenantId: this.props.user.queryParams.tenantId,
        reportId: this.props.params.id,
      })
      .then(() =>
        this.props.getCIRReport(this.props.params.id, {
          tenantId: this.props.user.queryParams.tenantId,
        })
    )
  };

  onUpdateSubmit = (id, message) => {
    this.props
      .updateMessage(id, message, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getCIRReport(this.props.params.id, {
          tenantId: this.props.user.queryParams.tenantId,
        })
      );
  };

  onDeleteSubmit = (id) => {
    this.props
      .deleteMessage(id, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getCIRReport(this.props.params.id, {
          tenantId: this.props.user.queryParams.tenantId,
        })
      );
  };

  downloadFile(reportId, fileName) {
    this.props
      .downloadFile(
        reportId,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        fileName,
      )
      .then((response) => {
        const blob = response.payload;
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  }

  previewFile(reportId, filename) {
    this.props
      .previewFile(
        reportId,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        filename,
      )
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
        this.setState({ showPreview: true });
      });
  }

  closePreview() {
    this.setState({ showPreview: false });
  }

  render() {
    const {
      data: { report, isCIRLoading, isFilesUploading, types, childTypes },
      client: { client },
      patient: { patient },
      isExecutive,
      isSuperAdmin,
      isClinicalComplianceManager,
      user
    } = this.props;

    const filesToUpload = this.state.files.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
        <br />
        {/*<input className="form-control" placeholder="Title" onChange={this.handleTitleChange.bind(this)}></input>*/}
        {/*<input className="form-control" placeholder="Description" onChange={this.handleDescriptionChange.bind(this)}></input>*/}
      </li>
    ));

    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/x-photoshop, audio/mpeg, audio/x-m4a, application/ogg, video/mp4, video/mpeg4, video/x-m4v, video/quicktime, video/x-ms-wmv, video/avi, video/mpeg, video/ogg, video/3gpp, video/3gpp2';

    return (
      <div id="content">
        {report.id && (
          <Helmet title={`${report.id} – ${hostTitle()}`} />
        )}
        <BigBreadcrumbs
          items={[
            'Clinical Occurrence Report',
            { title: 'Clinical Occurrence Reports', route: '/cir-manager' },
            'Clinical Occurrence'
          ]}
          icon="fa fa-fw fa-tasks"
          className=""
        />
        <WidgetGrid>
          <JarvisWidget
            color="white"
            fullscreenbutton={true}
            colorbutton={false}
            closeButton={true}
            editbutton={false}
            togglebutton={false}
            deletebutton={false}
          >
            <header>
              <span className="widget-icon">
                {' '}
                <i className="fa fa-table" />{' '}
              </span>
              <h2>Edit Report</h2>
            </header>
            <div>
              <div className="row">
                <div className="col-lg-7 col-md-12 col-sm-12 col-xs-12 ">
                  <div className="row">
                    <div className="col-md-9">
                      <span> Report Id: {report.id} </span>
                    </div>
                    <div className="col-md-3">
                      <button
                        className="btn btn-primary pull-right"
                        onClick={this.onCancel}
                      >
                        Back
                      </button>
                    </div>
                  </div>
                  {report.id && (
                    <ClinicalIncidentForm
                      searchUsers={this.searchUsers}
                      searchTaskUsers={this.searchTaskUsers}
                      searchLocations={this.searchLocations}
                      isExecutive={isExecutive}
                      searchClients={this.searchClients}
                      searchPatients={this.searchPatients}
                      searchStatuses={this.searchStatuses}
                      searchTimeZones={this.searchTimeZones}
                      searchPatientHealthTypes={this.searchPatientHealthTypes}
                      searchVisitorHealthTypes={this.searchVisitorHealthTypes}
                      searchEmployeeHealthTypes={this.searchEmployeeHealthTypes}
                      searchTypes={this.searchTypes}
                      searchGenders={this.searchGenders}
                      types={types}
                      mode={this.props.params.mode}
                      childTypes={childTypes}
                      onSubmit={this.onSubmit}
                      onCancel={this.onCancel}
                    />
                  )}
                </div>

                {/*Comments, History and Attachments Section*/}
                {this.props.params.mode !== 'Add' && (
                  <div className="col-lg-5 col-md-12 col-sm-12 col-xs-12 ">
                    <legend>Attachments</legend>
                    <small className="help-block">Image files, PDFs, Word, Excel, Audio, Video...</small>
                    <div className="form-group">
                      <div className="col-lg-12 padding-bottom-10">
                        {report.files &&
                          report.files.map((file) => (
                            <li className="list-group-item" key={file.fileName}>
                              <span className="filename">{file.fileName} </span>
                              {` `}
                              <button
                                className="btn btn-xs btn-default"
                                onClick={() =>
                                  this.downloadFile(report.id, file.fileName)
                                }
                              >
                                <i className="fa fa-download" />
                              </button>
                              {` `}
                              <button 
                                className="btn btn-xs btn-default"
                                onClick={() =>
                                  this.previewFile(report.id, file.fileName)
                                }
                              >
                                <i className="fa fa-file" />
                              </button>
                              {` `}
                              <button disabled={!(isSuperAdmin || isClinicalComplianceManager)}
                                className="action btn btn-xs btn-danger"
                                onClick={() => this.deleteFile(report.id, file.fileName)}
                              >
                                <i className="fa fa-close" />
                              </button>
                            </li>
                          ))}
                        <button
                          className="btn btn-primary"
                          onClick={this.showModal.bind(this)}
                        >
                          Add Attachment
                        </button>
                      </div>
                    </div>
                    <legend className="padding-top-10">Comments</legend>
                    <div>
                      <CommentForm isExecutive={isExecutive}
                        onSubmit={this.onAddSubmit}
                        parentId={null}
                      />
                      {isCIRLoading && <div className="spinner" />}
                      <Comments isExecutive={isExecutive}
                        comments={
                          report.comments 
                            ? report.comments
                            : []
                        }
                        userid={user.data.id}
                        mode={true}
                        onUpdateSubmit={this.onUpdateSubmit}
                        onDeleteSubmit={this.onDeleteSubmit}
                        onSubmit={this.onAddSubmit}
                      />
                    </div>
                    <legend>History</legend>
                    {report && report.histories && (
                      <div className="table-responsive">
                        <div className="col-lg-12">
                          <table className="table table-bordered table-condensed">
                            <thead>
                              <tr>
                                <th>Action</th>
                                <th>Name</th>
                                <th>Date</th>
                                <th>Time</th>
                                <th>User</th>
                              </tr>
                            </thead>
                            <tbody>
                              {report && report.histories.map((rep) => (
                                <tr key={rep.id}>
                                  <td>{rep.action}</td>
                                  <td>{rep.name}</td>
                                  <td><Moment
                                    date={rep.createdAt}
                                    format="MM/DD/YYYY"
                                  /></td>
                                  <td><Moment
                                    date={rep.createdAt}
                                    format="hh:mm a"
                                  /></td>
                                  <td>{rep.createdByName}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {report && !report.histories && <div>N/A</div>}
                  </div>
                )}
                <Modal show={this.state.showUpload}>
                  <Modal.Header>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                      onClick={this.closeModal.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title" id="addFilesModalLabel">
                      Add Files
                    </h4>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row client-files-upload">
                      <div
                        className={
                          this.state.files.length > 0
                            ? 'col-sm-12'
                            : 'col-sm-12'
                        }
                      >
                        <Dropzone
                          accept={acceptedFiles}
                          onDrop={this.onDrop.bind(this)}
                          onFileDialogCancel={this.onFileCancel.bind(this)}
                        >
                          {({
                            getRootProps,
                            getInputProps,
                            isDragActive,
                          }) => {
                            return (
                              <div
                                {...getRootProps()}
                                className={classNames(
                                  'dropzone dropzone-client-files',
                                  { 'dropzone--isActive': isDragActive },
                                )}
                              >
                                <input {...getInputProps()} />
                                {isDragActive ? (
                                  <p>Drop files here...</p>
                                ) : (
                                  <span className="text-center">
                                    <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                      <span className="font-lg">
                                        Drop files{' '}
                                        <span className="font-xs">
                                          to upload
                                        </span>
                                      </span>
                                      <span>
                                        &nbsp;&nbsp;
                                        <h4 className="display-inline">
                                          {' '}
                                          (Or Click)
                                        </h4>
                                      </span>
                                    </span>
                                  </span>
                                )}
                              </div>
                            );
                          }}
                        </Dropzone>
                      </div>
                      {this.state.files.length > 0 && (
                        <div className="col-sm-12">
                          <h4>Files to be uploaded</h4>
                          <ul className="list-group files-upload-list">
                            {filesToUpload}
                          </ul>
                          {` `}
                          {this.state.files.length === 1 && (
                            <h6 className="txt-color-red">Only one file per request accepted.</h6>
                          )}
                          {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                        </div>
                      )}
                    </div>
                  </Modal.Body>
                  <Modal.Footer>
                    <button
                      type="button"
                      className="btn btn-default"
                      data-dismiss="modal"
                      onClick={this.closeModal.bind(this)}
                      disabled={isFilesUploading}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={this.state.files.length === 0}
                      onClick={this.onStartUpload.bind(this)}
                    >
                      Upload Files
                    </button>
                  </Modal.Footer>
                  {isFilesUploading && (
                    <div className="cover">
                      <div className="spinner" />
                    </div>
                  )}
                </Modal>

                <Modal
                  show={this.state.showPreview}
                  dialogClassName="modal-lg"
                >
                  <Modal.Header>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-hidden="true"
                      onClick={this.closePreview.bind(this)}
                    >
                      &times;
                    </button>
                    <h4 className="modal-title">File Viewer</h4>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="widget-body">
                      {
                        <FileViewer
                          fileType={this.state.fileType}
                          filePath={this.state.fileName}
                        />
                      }
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </div>
          </JarvisWidget>
        </WidgetGrid>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    data: state.cirmanager,
    users: state.users,
    comments: state.comments,
    user: state.currentUser,
    client: state.clientmanager,
    patient: state.patients,
    isExecutive: isExecutive(state),
    isClinicalComplianceManager: isClinicalComplianceManager(state),
    isSuperAdmin: isSuperAdmin(state),
  }),
  (dispatch) => ({
    getCIRReport: (id, params) =>
      dispatch(requestCIRReport(id, params)),
    getPatient: (masterPatientId, params) =>
      dispatch(requestPatient(masterPatientId, params)),
    //getEscalationTypes: (params) => dispatch(requestEscalationTypes(params)),
    getUsersTypeahead: (params) => dispatch(requestUsersTypeahead(params)),
    getCurrentUser: () => dispatch(requestUserInfo()),
    clientsTypeahead: (params) => dispatch(requestClientsTypeahead(params)),
    patientsTypeahead: (params) => dispatch(requestPatientsTypeahead(params)),
    locationsTypeahead: (params) =>
      dispatch(requestClinicLocationsTypeahead(params)),
    hintLocationTypeahead: (params) =>
      dispatch(requestHintLocationTypeahead(params)),

    getClientEscalation: (escalationId, params) =>
      dispatch(requestClientEscalation(escalationId, params)),
    saveReport: (report, params) =>
      dispatch(saveCIRReport(report, params)),
    saveReportTasks: (tasks, id, params) => dispatch(saveCIRReportTasks(tasks, id, params)),
    getAllLookups: (params) => dispatch(requestAllLookups(params)),
    getGenders: (params) => dispatch(requestGenders(params)),
    getIncidentStatuses: (params) => dispatch(requestIncidentStatuses(params)),
    getImpactedTypes: (params) => dispatch(requestImpactedTypes(params)),
    getPatientHealthTypes: (params) => dispatch(requestPatientHealthTypes(params)),
    getVisitorHealthTypes: (params) => dispatch(requestVisitorHealthTypes(params)),
    getEmployeeHealthTypes: (params) => dispatch(requestEmployeeHealthTypes(params)),
    getPatientHealthTypesByTypeId: (params) => dispatch(requestPatientHealthTypesByParentId(params)),
    uploadFiles: (id, params, files) => dispatch(uploadCIReportFiles(id, params, files)),
    downloadFile: (id, params, file) => dispatch(downloadCIReportFile(id, params, file)),
    previewFile: (id, params, file) => dispatch(previewCIReportFile(id, params, file)),
    deleteFile: (reportId, fileName, params) => dispatch(deleteCIReportFile(reportId, fileName, params)),
    addMessage: (message, params) => dispatch(addCIReportComment(message, params)),
    updateMessage: (id, message, params) => dispatch(updateCIReportComment(id, message, params)),
    deleteMessage: (id, params) => dispatch(deleteCIReportComment(id, params)),
    getTimeZones: (params) => dispatch(requestTimeZones(params)),
  }),
)(ClinicalIncidentReportEdit);



// WEBPACK FOOTER //
// ./src/routes/administration/containers/ClinicalIncidentReportEdit.js